import { render, staticRenderFns } from "./service-program-tit.vue?vue&type=template&id=8abd21b4&scoped=true&"
import script from "./service-program-tit.vue?vue&type=script&lang=js&"
export * from "./service-program-tit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abd21b4",
  null
  
)

export default component.exports